export const WIFI = 'Wi-Fi';
export const CELLULAR = 'Cellular';
